import { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { useMinutesSecondsTimer } from 'hooks/useMinutesSecondsTimer'
import { quoteAtom } from '../atoms/atoms'

export const useCountdownHighlight = (onExpiry: () => void) => {
  const quote = useAtomValue(quoteAtom)
  const totalExpiry = Math.round(
    (new Date(quote?.acceptanceExpiryDate).getTime() - new Date().getTime()) / 1000
  )
  const { formattedTime, timeLeft, resetTimer } = useMinutesSecondsTimer(
    0,
    totalExpiry,
    true,
    onExpiry
  )

  useEffect(() => {
    if (timeLeft) return

    resetTimer()
  }, [timeLeft])

  return {
    formattedTime,
    timeLeft,
    resetTimer,
  }
}
